import { FC } from 'react';

export const CustomBlockQuoteComponent: FC = ({ children }) => (
  <blockquote className="m-0 mt-3 first:mt-0 pl-4 border-2 border-t-0 border-b-0 border-r-0 border-solid border-gray-300">
    {children}
  </blockquote>
);
